export const PROVIDER_CONFIG = {
    apple: {
        authorizationEndpoint: "https://appleid.apple.com/auth/authorize",
        tokenEndpoint: "https://appleid.apple.com/auth/token",
        clientId: process.env.VUE_APP_MIX_APPLE_CLIENT_ID ?? "",
        scopes: ["email", "name"],
        redirectUri: (process.env.VUE_APP_IMMOWEB_URL ?? "") + (process.env.VUE_APP_MIX_APPLE_CALLBACK_URL ?? ""),
    },
    google: {
        authorizationEndpoint: "https://accounts.google.com/o/oauth2/auth",
        tokenEndpoint: "https://oauth2.googleapis.com/token",
        clientId: process.env.VUE_APP_MIX_GOOGLE_CLIENT_ID ?? "",
        scopes: ["openid", "email", "profile"],
        redirectUri: (process.env.VUE_APP_IMMOWEB_URL ?? "") + (process.env.VUE_APP_MIX_GOOGLE_CALLBACK_URL ?? ""),
    },
};

export function getOAuthConfig(provider: "apple" | "google"): any {
    return PROVIDER_CONFIG[provider];
}

export function buildAuthorizationUrl(config: any, codeChallenge: string, state: string, nonce: string, provider: string): string {
    const params = new URLSearchParams({
        client_id: config.clientId,
        redirect_uri: config.redirectUri,
        response_type: "code",
        scope: config.scopes.join(" "),
        state: state,
        code_challenge: codeChallenge,
        code_challenge_method: "S256",
        nonce: nonce,
    });

    // Apple requires response_mode=form_post
    if (provider === "apple") {
        params.set("response_mode", "form_post");
    }

    return `${config.authorizationEndpoint}?${params.toString()}`;
}

export function generateState(provider: "apple" | "google", mode = "link"): string {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);

    const randomString = btoa(String.fromCharCode(...array))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");

    const stateData = {
        provider: provider,
        mode: mode,
        nonce: randomString,
    };

    return btoa(JSON.stringify(stateData));
}
